<template>
  <c-search-form :input-search-items="searchItems"
                 :form-name="formName"
                 :hiddenFields="hiddenFields"
                 model="searchForm" :fields="fields"
                 key-property="logId"
                 :search-url="searchUrl"
                 :accept-create="false"
                 :accept-delete="false"
                 @showImage="showImage"
                 :acceptDownload="2"
                 @dowloadImage="dowloadImage"
  >
  </c-search-form>
</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";

export default {
  name: 'search-image',
  components: {CSearchForm},
  data: () => {
    return {
      formName: "Tra cứu giấy khen",
      searchUrl: null,
      searchItems: [
        {
          type: "text",
          name: "phoneNumber",
          label: "Số điện thoại",
          placeHolder: "",
          focus: true
        },
      ],
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'phoneNumber',
          text: 'Username',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'accountName',
          text: 'Tên học sinh',
          width: "5%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        /*        {
                  value: 'certificate',
                  text: 'Giấy chứng nhận',
                  sortable: false,
                  type: "link",
                  search: false,
                  width: "10%",
                  headerStyle: "text-align:center",
                },*/
        {
          value: 'custom_action_list',
          width: "5%",
          text: 'Giấy chứng nhận',
          headerStyle: "text-align:center;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 2",
              icon: "visibility",
              event: "showImage",
              color: "primary"
            },
          ],
        },
        {
          value: 'custom_action_list',
          text: 'Tải xuống',
          width: "5%",
          headerStyle: "text-align:center;",
          items: [
            {
              text: "Nội dung nhiệm vụ thứ 2",
              icon: "file_download",
              event: "dowloadImage",
              color: "primary"
            },
          ],
        },
      ]
    }
  },
  methods: {
    showImage(item) {
      window.open("https://static.babilala.vn/" + item.certificate, '_blank').focus();
    },

    async dowloadImage(item) {
      const fileName = 'https://static.babilala.vn/' + item.certificate;

      try {
        const response = await fetch(fileName)
        const blob = await response.blob();
        const url = await URL.createObjectURL(blob)

        const a = document.createElement("a");
        a.href = url;
        a.download = item.phoneNumber + "_" + item.accountName + ".png";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.log({err})
      }
    }
  },
  created() {
    this.searchUrl = "/kidAccountClass/searchImageByPhoneOrUsername2024?sortField=status,classId&";
  }

}
</script>
